import React, { useCallback } from 'react';
import SshHostKeyPromptModal from './SshHostKeyPromptModal';
import SshHostKeyChangedModal from './SshHostKeyChangedModal';
import { useSshHostKeyEvents } from '../../hooks/useSshHostKeyEvents';
import { useExtensionStore } from '../../extensions/store';
import { setSettingsInitialTab, setSettingsModalOpen } from '../../store/uiModalStore';

/**
 * Always-mounted host for SSH host-key prompts and changed-key warnings.
 *
 * Root-mounted for the reason `BridgePairHost` gives: a connect can start from
 * the SFTP browser, a terminal tab or a restored layout on any panel, and Rust
 * blocks on the verdict. A listener scoped to one panel means the event fires
 * with nothing painting the card and the connect is cancelled at 90 s.
 */
export default function SshHostKeyHost() {
  const { prompt, conflict, respond, changed, dismissChanged } = useSshHostKeyEvents();
  const terminalOn = useExtensionStore((s) => !!s.enabled?.['com.apiboo.terminal']);

  const openSettings = useCallback(() => {
    dismissChanged();
    // Known hosts is listed on both the Terminal and the FTP settings pages.
    setSettingsInitialTab(
      terminalOn ? 'extensions:com.apiboo.terminal' : 'extensions:com.apiboo.ftp'
    );
    setSettingsModalOpen(true);
  }, [dismissChanged, terminalOn]);

  return (
    <>
      <SshHostKeyPromptModal prompt={prompt} conflict={conflict} onRespond={respond} />
      {!prompt && (
        <SshHostKeyChangedModal
          changed={changed}
          onClose={dismissChanged}
          onOpenSettings={openSettings}
        />
      )}
    </>
  );
}
